import { Stack } from '@mui/material';
import React, { useEffect, useState } from "react";
import { signInWithGoogleWithRedirect, signInWithTwitterWithRedirect } from "../../../../commands/firebase/signInWith"
import { signInWithDiscord } from "../../../../commands/discord/signInWith"
import TwitterIcon from '@mui/icons-material/Twitter';
import { EDButton, EDButtonType, EDIcon, EDTypography } from "@trailblazer-game/ed-webkit";
import { useWallet } from '@solana/wallet-adapter-react';
import { Connection, PublicKey } from "@solana/web3.js";
import { bs58 } from '@project-serum/anchor/dist/cjs/utils/bytes';
import { buildAuthTx } from "../../../../commands/memosign/MemoSign";
import { signUp } from '../../../../commands/user/signUp';
import { SessionContext, SessionContextInterface } from "../../../../hooks/SessionHook/SessionContext";
import { useWalletModal } from "@solana/wallet-adapter-react-ui";

//
interface ISsoProps {
    header: string;
    showMain: boolean;
    mainLabel?: string;
    onReqEnd: Function;
}

//
export default function SsoUi(props: ISsoProps) {
    const { hasSession } = React.useContext(SessionContext) as SessionContextInterface;
    const { setVisible: setWalletModalVisible } = useWalletModal();
    const {
        publicKey,
        signTransaction,
        disconnect,
        connected
    } = useWallet();

    const [ urlOrigin, setUrlOrigin ] = useState<string>('');
    const [ allowWalletLogin, setAllowWalletLogin ] = useState(false);

    useEffect(() => {
        // Disconnect wallet on start - just in case!
        disconnect();

        setUrlOrigin(window.location.origin);
    }, [])

    //
    async function onSSO(provider: string) {
        let res: any = null;

        if (provider === 'twitter') {
            res = await signInWithTwitterWithRedirect();
        } else if (provider === 'google') {
            res = await signInWithGoogleWithRedirect();
        }

        props.onReqEnd(provider, res);
    }

    async function onTwitterSSO() {
        await onSSO("twitter");
    }

    async function onGoogleSSO() {
        await onSSO("google");
    }

    function onDiscordSSO() {
        signInWithDiscord(urlOrigin);
    }

    function onWalletConnect() {
        if (!hasSession()) {
            //disconnect()
            setAllowWalletLogin(true);
            //(document.getElementsByClassName('wallet-adapter-button')[0] as HTMLElement).click();
            setWalletModalVisible(true);
        }
    }

    //
    useEffect(() => {

        if (allowWalletLogin && !hasSession()) {
            if (publicKey && signTransaction && connected) {
                //facade.setUserAddress(base58);
                //  setKey(keyToDisplay)
                console.log("Can sign tx ", signTransaction);

                setAllowWalletLogin(false);

                signTx(publicKey, publicKey.toBase58());
            }
        }

    }, [ publicKey, signTransaction, setAllowWalletLogin, connected ]);

    //
    function signTx(publicKey: PublicKey, base58: string) {
        console.log("invoke signtx");

        if (signTransaction) {
            getConnection().getLatestBlockhash().then((blockhash: any) => {
                const tx = buildAuthTx("Welcome to Eternal Dragons")
                tx.feePayer = publicKey // not sure if needed but set this properly
                tx.recentBlockhash = blockhash.blockhash;
                // Encode and send tx to signer, decode and sign

                signTransaction(tx).then(signedTx => {
                    let buffer = signedTx.serialize();
                    console.log("Buffer", buffer);

                    signUp(base58, bs58.encode(buffer), true).then((res: any) => {

                        if (res.status < 0 || res.data.success === false) {
                            disconnect();
                        }

                        // This will be called after signUp request is done!!
                        props.onReqEnd('wallet', res);
                    })
                    //const validSignature = validateAuthTx(signedTx, "test-nonce")
                }, e => {
                    // Disconnect wallet!
                    disconnect();
                    console.log("signTransaction error", e);
                });
            });
        }
    }

    //FIXME: Should be in util
    function getConnection(): Connection {

        let customRpcUrl = process.env.NEXT_PUBLIC_SOLANA;
        //"http://127.0.0.1:8899" //process.env.ANCHOR_PROVIDER_URL;

        let connection = new Connection(
            //@ts-ignore
            customRpcUrl
        );

        return connection;
    }

    return (
        <>
            {props.header && <EDTypography variant={"body1"}>
                {props.header}
            </EDTypography>}

            {props.showMain &&
                <EDButton onClick={onGoogleSSO} type={EDButtonType.Primary}
                          icon={<EDIcon icon={"/google-sign.png"}/>}
                          label={"Continue with Google"}
                          aria={{ label: "Login with Google" }}
                          sx={{ width: '100%' }}/>
            }

            {!props.showMain &&
                <Stack alignItems={"center"} justifyContent={"space-between"} spacing={2} direction={"row"}
                       sx={{ width: '100%' }}>
                    <EDButton onClick={onTwitterSSO} type={EDButtonType.Bones} icon={<TwitterIcon/>}
                              aria={{ label: "Login with Twitter" }}/>
                    <EDButton onClick={onDiscordSSO} type={EDButtonType.Bones}
                              icon={<EDIcon icon={"/discord-logo-blue.png"}/>}
                              aria={{ label: "Login with Discord" }}/>
                    <EDButton onClick={onWalletConnect} type={EDButtonType.Bones}
                              icon={<EDIcon icon={"/solana-logo.png"}/>}
                              aria={{ label: "Login with a Solana wallet" }}/>
                </Stack>}
        </>
    )
}